/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-12-28 15:08:59
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2023-01-03 17:10:37
 * @FilePath: \ioc_base\src\modules\firePatrol\api\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const api = {
  getFirePatrolItems: "/bms/firepatrol/queryFirePatrolList.json", //获取巡检项，
  delFirePatrolItems: "/bms/firepatrol/deleteFirePatrol.json", //删除巡检项
  updateFirePatrolItems: "/bms/firepatrol/updateFirePatrol.json", //修改巡检项
  addFirePatrolItems: "/bms/firepatrol/addFirePatrol.json", //新增巡检项
  detailFirePatrolItems: "/bms/firepatrol/queryFirePatrolInfo.json", //详情巡检项
  getFirePatrolRecord: "/bms/firepatrol/queryStatisticFirePatrolRecord.json", //查询巡查统计
  getFirePatrolRecordList: "/bms/firepatrol/queryFirePatrolRecordList.json" ,//查询巡查统计list
  updateFirePatrolRecordList: "/bms/firepatrol/updateFirePatrolRecord.json", //修改防火巡查记录
  updateFirePatrolStatus: "/bms/firepatrol/updateFirePatrolStatus.json" //修改防火巡查记录
};
